import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputDateRangeComponent } from './form-input-date-range.component';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormInputDateRangeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormInputErrorModule,
    DatePickerModule,
    FormsModule,
  ],
  exports: [
    FormInputDateRangeComponent
  ]
})
export class FormInputDateRangeModule { }
